export default __webpack_public_path__ + "static/media/language.734d8944.png";